export default "__VITE_ASSET__B46g0k6E__"